import React from 'react';
import { ATTENDANCE_SUBVIEW_MODEL } from '../Model/Model';
import GlobalTable from './Global/SubComponents/GlobalTable';
import ByDepartmentTable from './ByDepartment/ByDepartmentTable';

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const OvertimePoliciesTab = ({
    subView,
    changeSubViewManage,
    registerAction,
    option,
    setBodyForExport,
    searchElement,
    setSearchElement,
    setSimpleSearch,
    search,
    setSearch,
    modified,
    setModified,
    activeStep,
    selectForDelete,
    setSelectForDelete,
}) => {
    return (
        <>
            {subView === ATTENDANCE_SUBVIEW_MODEL.OVERTIME_POLICIES.GLOBAL && (
                <GlobalTable
                    subView={subView}
                    changeSubViewManage={changeSubViewManage}
                    option={option}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSimpleSearch={setSimpleSearch}
                    search={search}
                    setSearch={setSearch}
                    modified={modified}
                    setModified={setModified}
                    registerAction={registerAction}
                    activeStep={activeStep}
                    selectForDelete={selectForDelete}
                    setSelectForDelete={setSelectForDelete}
                />
            )}
            {subView === ATTENDANCE_SUBVIEW_MODEL.OVERTIME_POLICIES.BY_DEPARTMENT && (
                <ByDepartmentTable
                    subView={subView}
                    changeSubViewManage={changeSubViewManage}
                    option={option}
                    setBodyForExport={setBodyForExport}
                    searchElement={searchElement}
                    setSearchElement={setSearchElement}
                    setSimpleSearch={setSimpleSearch}
                    search={search}
                    setSearch={setSearch}
                    modified={modified}
                    setModified={setModified}
                    registerAction={registerAction}
                    activeStep={activeStep}
                    selectForDelete={selectForDelete}
                    setSelectForDelete={setSelectForDelete}
                />
            )}
        </>
    );
};

export default OvertimePoliciesTab;
